import { useCallback, useRef, useState } from 'react';
import { ConfirmDialog } from './ConfirmDialog';
import type { IConfirm } from './IConfirm';
import type { IConfirmRequest } from './IConfirmRequest';

/**
 * Підтвердження через діалог застосунку замість window.confirm: `confirm(запит)` повертає проміс із рішенням користувача; поки діалог
 * відкритий, повторний запит замінює попередній (попередній отримує відмову).
 */
export function useConfirm(): IConfirm {
  const [request, setRequest] = useState<IConfirmRequest | null>(null);
  const resolver = useRef<((ok: boolean) => void) | null>(null);
  const confirm = useCallback((next: IConfirmRequest) => new Promise<boolean>((resolve) => {
    resolver.current?.(false);
    resolver.current = resolve;
    setRequest(next);
  }), []);
  const close = useCallback((ok: boolean) => {
    resolver.current?.(ok);
    resolver.current = null;
    setRequest(null);
  }, []);
  return { confirm, dialog: request ? <ConfirmDialog {...request} onClose={close} /> : null };
}
